<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="propertyConditions" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="propertyConditionId" selectionMode="single"
  [(selection)]="propertyCondition" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Property Conditions</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Property Condition +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'createDate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'in')"></th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="categories"
            (onChange)="pt.filter($event.value, 'category', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="statuses"
            (onChange)="pt.filter($event.value, 'status', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="urgencies"
            (onChange)="pt.filter($event.value, 'urgency', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="rooms"
            (onChange)="pt.filter($event.value, 'room', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="reasons"
            (onChange)="pt.filter($event.value, 'reason', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="outcomes"
            (onChange)="pt.filter($event.value, 'outcome', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'costEst', 'in')"></th>
        <!--<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'enteredByUserId', 'in')"></th>-->
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="visibilities"
            (onChange)="pt.filter($event.value, 'visibility', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'opsNotes', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-propertyCondition>
    <tr [pSelectableRow]="propertyCondition">
      <td>{{propertyCondition.createDate | date}} </td>
      <td>{{getPropertyCode(propertyCondition?.shortTermRentalId)}}</td>
      <td>{{getCategoryName(propertyCondition)}}</td>
      <td>{{getStatusName(propertyCondition)}}</td>
      <td>{{getUrgencyName(propertyCondition)}}</td>
      <td>{{getRoomName(propertyCondition)}}</td>
      <td>{{propertyCondition.description}}</td>
      <td>{{getReasonName(propertyCondition)}}</td>
      <td>{{getOutcomeName(propertyCondition)}}</td>
      <td>{{propertyCondition.costEst}}</td>
      <!--<td>{{propertyCondition.enteredByUserId}}</td>-->
      <td>{{getvisibilityName(propertyCondition)}}</td>
      <td>{{propertyCondition.opsNotes}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(propertyCondition)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>